module.exports = __webpack_public_path__ + "static/media/blue.c55f647e.png";